export default __webpack_public_path__ + "static/media/card.e2732c2d.svg";